'use client';

import React, { useState } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HeroSection from './components/HeroSection';
import MasonryGrid from './components/MasonryGrid';
import StickyTicketBar from './components/StickyTicketBar';
import ContactSection from './components/ContactSection';
import CalendarSection from './components/CalendarSection';
import BookingModal from './components/BookingModal';

export default function HomePage() {
  const [bookingOpen, setBookingOpen] = useState(false);

  return (
    <main
      className="min-h-screen"
      style={{ background: '#0B0B0F' }}
    >
      <Header onBookNow={() => setBookingOpen(true)} />
      <HeroSection onBookNow={() => setBookingOpen(true)} />
      <MasonryGrid />
      <CalendarSection onBookNow={() => setBookingOpen(true)} />
      <ContactSection />
      <Footer />
      <StickyTicketBar />
      <BookingModal isOpen={bookingOpen} onClose={() => setBookingOpen(false)} />
    </main>
  );
}